//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  name:'book',
  components: {
  },
  props:{
    img:String,
    title:{
      type: String,
      required: true
    },
    text:{
      type: String,
      required: true
    },
    classification:{
      type: String,
      default: 'JavaScript'
    },
    link:{
      type: String
    }
  },
  data () {
    return {
      // note: changing this line won't causes changes
      // with hot-reload because the reloaded component
      // preserves its current state and we are modifying
      // its initial state.
      seemore:{
        height:''
      },
      see:false,
      show:true
    }
  },
  methods:{
    go(e){
      console.log(e);
      if (this.link) {
        if (this.link.indexOf('http')>-1) {
          window.open(this.link)
        }else{
          this.$router.push(this.link)
        }
      }
    },
    more(){
      if (this.see) {
        this.seemore.height = '3em'
      }else {
        this.seemore.height = 'auto';
      }
      this.see = !this.see
    },
    close(){
      const _this = this
      this.$vux.confirm.show({
        title: '删除?',
        content: '确定删除该文章',
    onCancel () {
    },
    onConfirm () {
    _this.show = false
    _this.$vux.toast.show({
       text: '删除成功！',
       type:'success',
       isShowMask:true
      })
    }})
    },
    showtoast(){
      
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/book.vue